/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import type { FeedStoreService } from '../services/feed-store.service';

// FeedStore reports a failed page with a toast and resolves anyway. This store also sets `failed`,
// so a page can show an error alert with Retry; pass `{ toast: false }` when the page shows its own alert.
export function createFailureAwareStore(
  feedStore: FeedStoreService,
  fetchFeed: (params: any) => Promise<any>,
  storeParameters?: object,
  options?: { toast?: boolean },
): any {
  const store = feedStore.create((params) => {
    store.failed = false;
    return fetchFeed(params).catch((error) => {
      store.failed = true;
      throw error;
    });
  }, storeParameters, options);
  return store;
}
